import UserContext from "../../context/UserContext";
import { useContext } from "react";

function PageContainer(props) {
  const { isLogged, userData } = useContext(UserContext);
  const { role } = userData;
  return (
    <>
      <div className="flex flex-col content-center items-center h-auto py-32">
        <h1 className="text-2xl font-semibold">
          {props.title.charAt(0).toUpperCase() + props.title.slice(1)}
        </h1>
        {/* <hr className="w-4/5 mb-6" /> */}
        <br />
        {isLogged && role === "admin" && (
          <button
            className="btn w-36 bg-custom-blue text-black"
            onClick={props.onAddItem}
          >
            New {props.title.slice(0, -1)}
          </button>
        )}
        <ul className="menu bg-base-200 rounded-box mt-4 w-5/6 gap-4">
          {props.children}
        </ul>
      </div>
    </>
  );
}

export default PageContainer;
